import {useGetFAQQuery} from '@vio/core/src/sapi/services/searchApi'

/**
 * Hook to check if FAQs are available for a given hotel.
 *
 * Fetches FAQ data from the search API and determines whether the FAQ section
 * should be rendered on the accommodation page.
 *
 * @param hotelId - The hotel ID to fetch FAQs for. If empty, the query is skipped.
 * @returns An object containing:
 *   - `shouldRenderFaqs`: Boolean indicating if FAQs should be displayed (true when FAQs exist and no error)
 *   - `data`: The raw FAQ response data from the API
 *   - `isLoading`: Boolean indicating if the FAQ query is still loading

 */
export const useGetFaqsAvailibility = ({hotelId}: {hotelId: string}) => {
  const {data, isLoading, isError} = useGetFAQQuery({hotelId}, {skip: !hotelId})

  const shouldRenderFaqs = data?.faqs?.length > 0 && !isError

  return {shouldRenderFaqs, data, isLoading}
}
